import React from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';

import { RoundByRound } from '../components/round-by-round';

export const PlayerAwardsRoundByRoundProvider = ({ store, data }) => {
    return (
        <Provider store={store}>
            <RoundByRound {...data} />
        </Provider>
    );
};

PlayerAwardsRoundByRoundProvider.propTypes = {
    store: PropTypes.object.isRequired,
    data: PropTypes.object
};
